import { WorkOfflineDataFetcher } from '@skinsoft/data-store';
import { EntityDataStore } from '@skinsoft/entity-data-store';
import { API_ENDPOINTS } from '../../type-api-endpoint-mapping';

export interface Work {
    id: string;
    type: string;
}

export class WorkDataStore extends EntityDataStore<Work> {
    public static getInstance() {
        if (!WorkDataStore.instance) {
            WorkDataStore.instance = new WorkDataStore();
        }

        return WorkDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$workDataStore = WorkDataStore.getInstance();
    }

    private static instance: WorkDataStore = null as any;

    constructor() {
        super('works');
    }

    public update(id: string, body: Partial<Work>, endpointOverride?: string) {
        return super.update(id, body, endpointOverride || API_ENDPOINTS[body.type as string])
    }

    protected initializeDataFetcher() {
        this.offlineDataFetcher = new WorkOfflineDataFetcher("items"); // TODO refactor to constant
    }
}
